module.exports = __webpack_public_path__ + "img/GAME_MINHWATU.1aec610a.png";